import React from "react";
import { CircularLoadingIcon } from "SvgComponents";
import classes from "./LoadingComponent.scss";

const LoadingComponent = () => {
  return (
    <span className={classes.container}>
      <CircularLoadingIcon />
    </span>
  );
};

export default LoadingComponent;
